import { commonHelpers } from 'helpers/commonHelper';
import { getTableHeightFitContent } from 'helpers/lib/reactDataGridHelpers';
import { get } from 'lodash';
import { useCallback, useEffect, useState } from 'react';
import ReactDataGrid from 'react-data-grid';

const EmptyRowsView = () => {
    const message = 'Chưa có mục thu nào';
    return (
        <div style={{ textAlign: 'center', backgroundColor: '#ddd', padding: '100px' }}>
            <h3>{message}</h3>
        </div>
    );
};

function DuThuCongDoanTable({ academicYear, danhmucthucongdoans, duthucongdoans, data, setData }) {
    const [rows, setRows] = useState([]);
    const [columns, setColumns] = useState([]);

    const numOfMonthForYear = get(academicYear, 'congDoanNumOfMonth', 12);

    const [tableHeight, setTableHeight] = useState();
    useEffect(() => {
        setTableHeight(getTableHeightFitContent());
    }, []);

    useEffect(() => {
        const rows = [];
        if (danhmucthucongdoans) {
            danhmucthucongdoans.forEach((dm) => {
                const matchedDuThuCongDoan = duthucongdoans ? duthucongdoans.find((duthu) => dm.code === duthu.danhMucThuCongDoanCode) : {};
                const row = {
                    dmId: dm.id,
                    code: dm.code,
                    name: dm.name,
                    id: get(matchedDuThuCongDoan, 'id'),
                    danhMucChiCongDoanCode: get(matchedDuThuCongDoan, 'danhMucThuCongDoanCode'),
                    junAmount: get(matchedDuThuCongDoan, 'junAmount', '') ? get(matchedDuThuCongDoan, 'junAmount') : '',
                    julAmount: get(matchedDuThuCongDoan, 'julAmount', '') ? get(matchedDuThuCongDoan, 'julAmount') : '',
                    augAmount: get(matchedDuThuCongDoan, 'augAmount', '') ? get(matchedDuThuCongDoan, 'augAmount') : '',
                    sepAmount: get(matchedDuThuCongDoan, 'sepAmount', '') ? get(matchedDuThuCongDoan, 'sepAmount') : '',
                    octAmount: get(matchedDuThuCongDoan, 'octAmount', '') ? get(matchedDuThuCongDoan, 'octAmount') : '',
                    novAmount: get(matchedDuThuCongDoan, 'novAmount', '') ? get(matchedDuThuCongDoan, 'novAmount') : '',
                    decAmount: get(matchedDuThuCongDoan, 'decAmount', '') ? get(matchedDuThuCongDoan, 'decAmount') : '',
                    janAmount: get(matchedDuThuCongDoan, 'janAmount', '') ? get(matchedDuThuCongDoan, 'janAmount') : '',
                    febAmount: get(matchedDuThuCongDoan, 'febAmount', '') ? get(matchedDuThuCongDoan, 'febAmount') : '',
                    marAmount: get(matchedDuThuCongDoan, 'marAmount', '') ? get(matchedDuThuCongDoan, 'marAmount') : '',
                    aprAmount: get(matchedDuThuCongDoan, 'aprAmount', '') ? get(matchedDuThuCongDoan, 'aprAmount') : '',
                    mayAmount: get(matchedDuThuCongDoan, 'mayAmount', '') ? get(matchedDuThuCongDoan, 'mayAmount') : '',
                    extraAmount1: get(matchedDuThuCongDoan, 'extraAmount1', '') ? get(matchedDuThuCongDoan, 'extraAmount1', '') : '',
                    extraAmount2: get(matchedDuThuCongDoan, 'extraAmount2', '') ? get(matchedDuThuCongDoan, 'extraAmount2', '') : '',
                    duchi: matchedDuThuCongDoan,
                };
                rows.push(row);
            });
            setRows(rows);
        }
    }, [duthucongdoans, danhmucthucongdoans]);

    const buildDynamicColumnBaseOnYear = useCallback(() => {
        const isEnableDuThu = commonHelpers.ableToPersitDuThuChi(academicYear?.name);
        if (numOfMonthForYear === 14) {
            return [
                { key: 'aprAmount', name: 'Tháng 4', editable: isEnableDuThu, width: 80 },
                { key: 'mayAmount', name: 'Tháng 5', editable: isEnableDuThu, width: 80 },
                { key: 'junAmount', name: 'Tháng 6', editable: isEnableDuThu, width: 80 },
                { key: 'julAmount', name: 'Tháng 7', editable: isEnableDuThu, width: 80 },
                { key: 'augAmount', name: 'Tháng 8', editable: isEnableDuThu, width: 80 },
                { key: 'sepAmount', name: 'Tháng 9', editable: isEnableDuThu, width: 80 },
                { key: 'octAmount', name: 'Tháng 10', editable: isEnableDuThu, width: 80 },
                { key: 'novAmount', name: 'Tháng 11', editable: isEnableDuThu, width: 80 },
                { key: 'decAmount', name: 'Tháng 12', editable: isEnableDuThu, width: 80 },
                { key: 'janAmount', name: 'Tháng 1', editable: isEnableDuThu, width: 80 },
                { key: 'febAmount', name: 'Tháng 2', editable: isEnableDuThu, width: 80 },
                { key: 'marAmount', name: 'Tháng 3', editable: isEnableDuThu, width: 80 },
                { key: 'extraAmount1', name: 'Tháng 4', editable: isEnableDuThu, width: 80 },
                { key: 'extraAmount2', name: 'Tháng 5', editable: isEnableDuThu, width: 80 },
            ];
        } else if (numOfMonthForYear === 10) {
            return [
                { key: 'junAmount', name: 'Tháng 6', editable: isEnableDuThu, width: 80 },
                { key: 'julAmount', name: 'Tháng 7', editable: isEnableDuThu, width: 80 },
                { key: 'augAmount', name: 'Tháng 8', editable: isEnableDuThu, width: 80 },
                { key: 'sepAmount', name: 'Tháng 9', editable: isEnableDuThu, width: 80 },
                { key: 'octAmount', name: 'Tháng 10', editable: isEnableDuThu, width: 80 },
                { key: 'novAmount', name: 'Tháng 11', editable: isEnableDuThu, width: 80 },
                { key: 'decAmount', name: 'Tháng 12', editable: isEnableDuThu, width: 80 },
                { key: 'janAmount', name: 'Tháng 1', editable: isEnableDuThu, width: 80 },
                { key: 'febAmount', name: 'Tháng 2', editable: isEnableDuThu, width: 80 },
                { key: 'marAmount', name: 'Tháng 3', editable: isEnableDuThu, width: 80 },
            ];
        } else {
            return [
                { key: 'junAmount', name: 'Tháng 6', editable: isEnableDuThu, width: 80 },
                { key: 'julAmount', name: 'Tháng 7', editable: isEnableDuThu, width: 80 },
                { key: 'augAmount', name: 'Tháng 8', editable: isEnableDuThu, width: 80 },
                { key: 'sepAmount', name: 'Tháng 9', editable: isEnableDuThu, width: 80 },
                { key: 'octAmount', name: 'Tháng 10', editable: isEnableDuThu, width: 80 },
                { key: 'novAmount', name: 'Tháng 11', editable: isEnableDuThu, width: 80 },
                { key: 'decAmount', name: 'Tháng 12', editable: isEnableDuThu, width: 80 },
                { key: 'janAmount', name: 'Tháng 1', editable: isEnableDuThu, width: 80 },
                { key: 'febAmount', name: 'Tháng 2', editable: isEnableDuThu, width: 80 },
                { key: 'marAmount', name: 'Tháng 3', editable: isEnableDuThu, width: 80 },
                { key: 'aprAmount', name: 'Tháng 4', editable: isEnableDuThu, width: 80 },
                { key: 'mayAmount', name: 'Tháng 5', editable: isEnableDuThu, width: 80 },
            ];
        }
    }, [numOfMonthForYear]);

    useEffect(() => {
        const commonColumns = [
            { key: 'code', name: 'Mã số', editable: false, width: 60 },
            { key: 'name', name: 'Diễn giải', editable: false, width: 360 },
        ];
        const dynamicColumns = buildDynamicColumnBaseOnYear();
        const columns = [...commonColumns, ...dynamicColumns].map((item) => {
            return { ...item, ...{ resizable: true } };
        });
        setColumns(columns);
    }, [buildDynamicColumnBaseOnYear]);

    const onGridRowsUpdated = ({ fromRow, toRow, updated, cellKey }) => {
        const newData = new Map(data);
        const newRows = [...rows];
        for (let i = fromRow; i <= toRow; i++) {
            newRows[i] = { ...newRows[i], ...updated };
            if (get(newRows[i], 'dm.id', false) || updated[cellKey] !== '') {
                newData.set(i, newRows[i]);
            }
        }
        setRows(newRows);
        setData(newRows);
    };

    return (
        <div id="rdg">
            <ReactDataGrid
                columns={columns}
                rowGetter={(i) => rows[i]}
                rowsCount={rows.length}
                minHeight={tableHeight}
                enableCellSelect={true}
                onGridRowsUpdated={onGridRowsUpdated}
                emptyRowsView={EmptyRowsView}
            />
        </div>
    );
}

export default DuThuCongDoanTable;
